<template>

    <div class="c-table">
        <h3 v-show="title">{{ title }}</h3>

        <div class="c-table__container">
            <div class="c-table__scroll" ref="container" @scroll.passive="scrolled = true">
                <table class="c-table__table">
                    <slot></slot>
                </table>
            </div>
            <span :class="{ 'c-table__arrow--hidden' : !isScrollable || scrolled }" class="c-table__arrow"></span>
        </div>
    </div>

</template>


<script>

export default {

    name: 'VTable',

    props: {
        title: String,
    },

    data() {
        return {
            isScrollable: false,
            scrolled: false
        }
    },

    methods: {
        isTouchDevice() {
            return 'ontouchstart' in window || navigator.msMaxTouchPoints
        },
        canScroll() {
            if (table.scrollLeft < (table.scrollWidth - table.clientWidth))
                table.parentNode.classList.add('canScroll');
            else
                table.parentNode.classList.remove('canScroll');
        },
        scrollbarExist() {
            return (this.$refs.container.scrollWidth > this.$refs.container.clientWidth);
        },
        resizeTable() {
            if (this.isTouchDevice() && this.scrollbarExist()) {
                this.isScrollable = true
            } else {
                this.isScrollable = false
            }
        }
    },

    mounted() {

        if (this.isTouchDevice()) {
            window.addEventListener('resize', this.resizeTable, false);
            if (this.scrollbarExist())
                this.isScrollable = true
        }

    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-table {
    width: 100%;

    &__container {
        position: relative;
        width: 100%;
    }
    &__scroll {
        width: 100%;
        height: auto;
        overflow-y: hidden;
        overflow-x: auto;
        margin-bottom: -15px;
    }
    &__table {
        min-width: 100%;
        table-layout: fixed;

        th {
            font-size: 0.75rem;
            text-transform: uppercase;
            color: $c-text-muted;
            letter-spacing: 0.08rem;
            padding: 0 0.7rem 1.2rem 0.7rem;
        }
        th,
        td {
            text-align: center;
            white-space: nowrap;
        }
        td {
            padding: 0.7rem 0.7rem;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
        th:first-child,
        td:first-child {
            padding-left: 0px;
            text-align: left;
        }
        td:first-child {
            font-weight: bold;
            color: $c-third;
        }
        th:last-child,
        td:last-child {
            padding-right: 0px;
            text-align: right;
        }
    }
    &__arrow {
        display: block;
        position: absolute;
        top: 50%;
        right: 1rem;
        width: 2rem;
        height: 2rem;
        transform: translate3d(0, -50%, 0);
        background-image: url('#{$icons}/arrow-right-green.svg');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        animation: scroll-tip 2s ease-in-out infinite;
        pointer-events: none;
        opacity: 1;

        &--hidden {
            opacity: 0;
        }
        @keyframes scroll-tip {
            50% {
                transform: translate3d(1rem, -50%, 0);
            }
        }
    }
}

</style>
